import React, { useState, useRef, useEffect, Fragment, memo } from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock'
import styles from '@/styles/Menu.module.scss'
import { urlpresents, urlmenu } from '@/lib/custom'
import { apiGet } from '@/lib/originalFetchApi'

const Menu = memo(() => {
  const router = useRouter()
  const [menuState, setMenuState] = useState(true)
  const [menuToggleState, setMenuToggleState] = useState(true)
  const menuElem = useRef(null)
  const { pathname } = router
  const s = pathname.split('/').filter(Boolean)

  const [presentscheck, setPresentscheck] = useState<Api.PresentsCheckResBody>()
  const [menu, setMenu] = useState<Api.menusResBody>()

  useEffect(() => {
    const fetchPresentscheck = async () => {
      const res: Api.PresentsCheckResBody = await apiGet(
        `${urlpresents}/check/`
      )
      setPresentscheck(res)
    }
    const fetchMenu = async () => {
      const res: Api.menusResBody = await apiGet(`${urlmenu}/`)
      setMenu(res)
    }

    fetchPresentscheck()
    fetchMenu()
  }, [])

  const LogOut = () => {
    localStorage.clear()
    location.href = `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/auth/signin`
  }

  const [targetElement, setTargetElement] = useState(null)

  useEffect(() => {
    clearAllBodyScrollLocks()
  }, [menuState])

  useEffect(() => {
    setTargetElement(menuElem.current)
  }, [])

  useEffect(() => {
    if (targetElement !== null) {
      if (menuState == false) {
        disableBodyScroll(targetElement)

        return
      }

      enableBodyScroll(targetElement)
      return
    }
  }, [menuState, targetElement])

  const heandleMenuOpen = (e) => {
    const { currentTarget } = e
    if (menuToggleState && currentTarget.classList.contains('is_close')) {
      setMenuState(false)
      currentTarget.classList.remove('is_close')
      enableBodyScroll(menuElem.current)
      setMenuToggleState(false)

      return
    }

    setMenuState(true)
    currentTarget.classList.add('is_close')
    enableBodyScroll(menuElem.current)
    setMenuToggleState(true)

    return
  }

  return (
    <nav>
      <div
        className={`${styles.c_menu_body}`}
        ref={menuElem}
        aria-hidden={menuState}
        id="c_menu"
      >
        <div className={styles.c_menu_contents}>
          {menu &&
            menu.menus &&
            menu.menus.map(
              (v: { url: string; type: number; name: string }, i) => {
                return (
                  <Fragment key={i}>
                    {!v.url.startsWith('/logout') ? (
                      <>
                        {(() => {
                          if (v.type === 1) {
                            return (
                              <button
                                onClick={() => {
                                  location.href = `/${process.env.NEXT_PUBLIC_SERVICE_NAME}${v.url}`
                                }}
                                className={`block text-h1 font-bold ${
                                  1 <= i ? 'mt-5' : ''
                                }`}
                              >
                                {v.name}
                              </button>
                            )
                          } else if (v.type === 2) {
                            return (
                              <a
                                href={`${v.url}`}
                                className={`block text-h1 font-bold ${
                                  1 <= i ? 'mt-5' : ''
                                }`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {v.name}
                              </a>
                            )
                          }
                        })()}
                      </>
                    ) : (
                      <div
                        className="mt-5 block text-h1 font-bold"
                        onClick={() => LogOut()}
                      >
                        {v.name}
                      </div>
                    )}
                  </Fragment>
                )
              }
            )}
          <a
            href="https://raund.net/terms/?no_layout=true"
            className={`mt-5 block text-h1 font-bold`}
            target="_new"
            rel="noopener"
          >
            利用規約
          </a>

          {menu ? (
            <div className="absolute bottom-[90px] right-[25px] text-[12px]">
              ID: {menu.user_id}
            </div>
          ) : null}
        </div>
      </div>
      <div
        className={`item-center flex items-center justify-between ${styles.c_menu}`}
      >
        <div className={`text-center ${styles.c_menu_button}`}>
          <Link
            href={{
              pathname: '/',
            }}
          >
            <a className={`block ${s[0] === undefined ? 'text-color02' : ''}`}>
              <span className={`${styles.c_menu_icon} block`}>
                <img
                  src={`${process.env.NEXT_PUBLIC_SITEURL}/${
                    process.env.NEXT_PUBLIC_SERVICE_NAME
                  }/images/img_home_${s[0] === undefined ? 'on' : 'off'}.svg`}
                  alt=""
                  className="m-auto"
                />
              </span>
              <p className="text-xs">ホーム</p>
            </a>
          </Link>
        </div>
        <div className={`text-center ${styles.c_menu_button}`}>
          <Link
            href={{
              pathname: '/spot/',
            }}
          >
            <a
              className={`block ${s[0] === 'spot' ? 'text-color02' : ''}`}
              aria-label="spotlink"
            >
              <span className={`${styles.c_menu_icon} block`}>
                <img
                  src={`${process.env.NEXT_PUBLIC_SITEURL}/${
                    process.env.NEXT_PUBLIC_SERVICE_NAME
                  }/images/img_spot_${s[0] === 'spot' ? 'on' : 'off'}.svg`}
                  alt=""
                  className="m-auto"
                />
              </span>
              <p className="text-xs">スポット</p>
            </a>
          </Link>
        </div>
        <div className={`text-center ${styles.c_menu_button}`}>
          <Link
            href={{
              pathname: '/rewards/',
            }}
          >
            <a
              className={`block ${s[0] === 'rewards' ? 'text-color02' : ''} ${
                presentscheck && presentscheck.count !== 0 ? styles.c_batch : ''
              }`}
            >
              <span className={`${styles.c_menu_icon} block`}>
                <img
                  src={`${process.env.NEXT_PUBLIC_SITEURL}/${
                    process.env.NEXT_PUBLIC_SERVICE_NAME
                  }/images/img_benefits_${
                    s[0] === 'rewards' ? 'on' : 'off'
                  }.svg`}
                  alt=""
                  className="m-auto"
                />
              </span>
              <p className="text-xs">特典情報</p>
            </a>
          </Link>
        </div>
        <div className={`text-center ${styles.c_menu_button}`}>
          <Link
            href={{
              pathname: '/rule/',
            }}
          >
            <a className={`block ${s[0] === 'rule' ? 'text-color02' : ''}`}>
              <span className={`${styles.c_menu_icon} block`}>
                <img
                  src={`${process.env.NEXT_PUBLIC_SITEURL}/${
                    process.env.NEXT_PUBLIC_SERVICE_NAME
                  }/images/img_rule_${s[0] === 'rule' ? 'on' : 'off'}.svg`}
                  alt=""
                  className="m-auto"
                />
              </span>
              <p className="text-xs">遊び方</p>
            </a>
          </Link>
        </div>
        <div className={`text-center ${styles.c_menu_button}`}>
          <button
            type="button"
            className="is_close"
            onClick={(e) => heandleMenuOpen(e)}
          >
            <span
              className={`flex flex-col justify-center ${styles.c_menu_icon}`}
            >
              <img
                src={`${process.env.NEXT_PUBLIC_SITEURL}/${
                  process.env.NEXT_PUBLIC_SERVICE_NAME
                }/images/img_menu_${menuState ? 'off' : 'on'}.svg`}
                alt=""
                className="m-auto"
              />
            </span>
            <span className="text-xs">メニュー</span>
          </button>
        </div>
      </div>
    </nav>
  )
})

export default Menu
